var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.748 14.4063H20.1462V9.74703C20.1462 7.57176 18.3765 5.80204 16.2011 5.80204C14.0258 5.80204 12.2561 7.57176 12.2561 9.74703V14.4063H9.6543V9.74703C9.6543 6.13712 12.5912 3.2002 16.2011 3.2002C19.811 3.2002 22.748 6.13706 22.748 9.74703V14.4063Z",
    fill: "#FAD416"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7477 9.74677V14.4065H20.1459V9.74677C20.1459 7.57163 18.3763 5.80204 16.2012 5.80204V3.2002C19.8108 3.2002 22.7477 6.13712 22.7477 9.74677Z",
    fill: "#FAD416"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4338 29.3336H20.9688C23.3651 29.3336 25.3076 27.391 25.3076 24.9948V14.1304H7.09497V24.9948C7.09497 27.391 9.03754 29.3336 11.4338 29.3336ZM16.2014 17.5896C17.5264 17.5896 18.6005 18.6638 18.6005 19.9888C18.6005 20.885 18.1087 21.666 17.3804 22.0779V26.0457L16.2014 26.046V26.0457H15.0223V22.0779C14.2941 21.666 13.8023 20.8851 13.8023 19.9888C13.8023 18.6638 14.8764 17.5896 16.2014 17.5896Z",
    fill: "#FAD416"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClock);
export default __webpack_public_path__ + "static/media/ic_clock.344fd24b2bf8f170a0092568840db63f.svg";
export { ForwardRef as ReactComponent };